export const iconFontAwesomeArrowsSort = (
	<i className="fa-solid fa-sort"></i>
);
